import React from "react";
import { observer } from "mobx-react";

import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";

import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { MyBetsBody } from "./MyBetsBody";

export const EventMyBetsContent = observer(function EventMyBetsContent() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.currentTab === EventBodyTabs.MyBets) {
		return <MyBetsBody />;
	}
	return null;
});
